webpackJsonp([9],{

/***/ 176:
/***/ (function(module, exports) {

module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.61189f04b2a93e58073b.js